export default "__VITE_ASSET__CaPGGv_R__"